import { render } from "./FlGroup.vue?vue&type=template&id=39e765d3"
import script from "./FlGroup.vue?vue&type=script&lang=js"
export * from "./FlGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__